import { render, staticRenderFns } from "./person-select.vue?vue&type=template&id=8e0f2222"
import script from "./person-select.vue?vue&type=script&lang=js"
export * from "./person-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports